import { first } from "rxjs/operators";
// Angular
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
// RxJS
import { tap, withLatestFrom, filter, mergeMap } from "rxjs/operators";
import { of, Observable, defer } from "rxjs";
// NGRX
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Action, Store, select } from "@ngrx/store";
// Auth actions
import {
  AuthActionTypes,
  Login,
  Logout,
  Register,
  UserRequested,
  UserLoaded
} from "../_actions/auth.actions";
import { AuthService } from "../_services/index";
import { AppState } from "../../reducers";
import { environment } from "../../../../environments/environment";
import { isUserLoaded } from "../_selectors/auth.selectors";
import { User } from "../_models/user.model";

@Injectable()
export class AuthEffects {
  @Effect({ dispatch: false })
  login$ = this.actions$.pipe(
    ofType<Login>(AuthActionTypes.Login),
    tap(action => {
      localStorage.setItem(environment.authTokenKey, action.payload.authToken);
      this.store.dispatch(new UserRequested());
    })
  );

  @Effect({ dispatch: false })
  logout$ = this.actions$.pipe(
    ofType<Logout>(AuthActionTypes.Logout),
    tap(() => {
      localStorage.removeItem(environment.authTokenKey);
      this.router.navigateByUrl("/auth/login");
    })
  );

  @Effect({ dispatch: false })
  register$ = this.actions$.pipe(
    ofType<Register>(AuthActionTypes.Register),
    tap(action => {
      localStorage.setItem(environment.authTokenKey, action.payload.authToken);
    })
  );

  @Effect({ dispatch: false })
  loadUser$ = this.actions$.pipe(
    ofType<UserRequested>(AuthActionTypes.UserRequested),
    withLatestFrom(this.store.pipe(select(isUserLoaded))),
    filter(([action, _isUserLoaded]) => !_isUserLoaded),
    mergeMap(([action, _isUserLoaded]) => this.auth.getUserByToken()),
    tap(res => {
      if (res) {
        const _user: User = new User();
        _user.firstName = res["result"]["firstName"];
        _user.lastName = res["result"]["lastName"];
        _user.isMale = res["result"]["isMale"];
        _user.username = res["result"]["username"];
        _user.role = res["result"]["role"];
        _user.userStatus = res["result"]["userStatus"];
        _user.isBeta = res["result"]["isBeta"];
        _user.walletBalance = res["result"]["walletBalance"];
        _user.userAffiliateStatus = res["result"]["userAffiliateStatus"];
        this.store.dispatch(new UserLoaded({ user: _user }));
      } else {
        this.store.dispatch(new Logout());
      }
    }, err => {
      if (err.error['statusCode'] && err.error['statusCode'] == 401) {
        this.store.dispatch(new Logout());
        this.router.navigateByUrl("/auth/login");
      }

    })
  );

  @Effect()
  init$: Observable<Action> = defer(() => {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let observableResult = of({ type: "NO_ACTION" });
    if (userToken) {
      observableResult = of(new Login({ authToken: userToken }));
    }
    return observableResult;
  });

  constructor(
    private actions$: Actions,
    private router: Router,
    private auth: AuthService,
    private store: Store<AppState>
  ) { }
}
